module.exports = __webpack_public_path__ + "static/img/bradesco.b33aa6a2.svg";